import clsx from 'clsx';
import React, {ReactChild, ElementType} from 'react';
import IconCross from 'react-feather/dist/icons/x';
import {useCookie} from '../../hooks/useCookie';
import defaultTheme from './trade-bar.module.pcss';

export type Props = {
  url: string;
  text: string;
  message: string;
  /**
   * Should show a close button
   * @default true
   */
  hasCloseButton?: boolean;
  close_link: string;
  /**
   * Days until cookie expiration
   * @default 30
   */
  lifetime?: number | string;
  /**
   * Element node
   * @default 'div'
   */
  as?: ElementType;
  children?: ReactChild;
  className?: string;
  /**
   * Name of cookie to check/set
   * @default 'trade-bar'
   */
  cookieName?: string;
  theme?: {
    root?: string;
    container?: string;
    button?: string;
    message?: string;
    closeLink?: string;
    link?: string;
    required?: string;
  };
};

export const TradeBar = ({
  as: ComponentProp = 'div',
  hasCloseButton = false,
  lifetime = 30,
  children,
  url,
  text,
  message,
  close_link,
  cookieName = 'trade-bar',
  className,
  theme = defaultTheme,
  ...rest
}: Props) => {
  const {required, saveCookie} = useCookie({cookieName, lifetime});

  const classes = clsx(theme.root, className, {
    [theme.required as any]: required,
  });

  return (
    <ComponentProp className={classes} {...rest}>
      {required && (
        <div className={theme.container}>
          <div className={theme.message}>{message}</div>
          <a href={url} className={theme.link}>
            {text}
          </a>
          <span
            className={theme.closeLink}
            onClick={saveCookie}
            onKeyDown={saveCookie}
          >
            {close_link}
          </span>
          {hasCloseButton && (
            <button
              className={theme.button}
              onClick={saveCookie}
              onKeyDown={saveCookie}
            >
              <IconCross />
            </button>
          )}
          {children}
        </div>
      )}
    </ComponentProp>
  );
};
